import { useMemo } from 'react';

import { getDevice } from '@/utils/utils';

const useDevice = () => {
  return useMemo(() => {
    const device = getDevice();
    const isIos = device === 'ios';
    const isPc = device === 'pc';
    const isAndroid = device === 'android';
    return {
      device,
      isAndroid,
      isIos,
      isPc
    };
  }, []);
};

export default useDevice;
